module.exports = __webpack_public_path__ + "assets/img/1414.13afa40c.png";